/**
 * Dirty flag: heartbeat só gera snapshot quando houve mudança (scroll, click, idle, visibility, mouse, keypress).
 * Evita snapshot repetido e reduz CPU.
 */

let isDirty = false;

export function setBehaviorDirty(): void {
  isDirty = true;
}

export function isBehaviorDirty(): boolean {
  return isDirty;
}

export function clearBehaviorDirty(): void {
  isDirty = false;
}

export function resetBehaviorDirty(): void {
  isDirty = false;
}
